module.exports = __webpack_public_path__ + "static/media/social_integration.21c6faee.svg";